import { GuideIcon } from '../icons/GuideIcon.jsx';
import { ICON_CHOICES } from '../config/palette.js';

/* 아이콘 선택 (큰 주제용) */
export function IconPicker({ value, onChange }) {
  return (
    <div className="iconpick">
      {ICON_CHOICES.map(n => (
        <button key={n} type="button" className={"iconpick__opt" + (value === n ? " is-on" : "")} onClick={() => onChange(n)} title={n}>
          <GuideIcon name={n} size={20} />
        </button>
      ))}
    </div>
  );
}

export default IconPicker;
